import React from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import '../../../utils/date';
import './DatePicker.less';
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-daterangepicker/daterangepicker.css';
import PropTypes from 'prop-types';
import moment from 'moment';

class DatePicker extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      dateSrting: this.props.startDate + ' - ' + this.props.endDate
    };
    this.handleEvent = this.handleEvent.bind(this);
  }

  static getDerivedStateFromProps (newpros, state) {
    if (
      newpros.startDate !== state.startDate ||
      newpros.endDate !== state.endDate
    ) {
      return {
        startDate: newpros.startDate,
        endDate: newpros.endDate,
        dateSrting: newpros.startDate + ' - ' + newpros.endDate
      };
    }
    return null;
  }

  convertDateToFormat (today) {
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();
    today = mm + '/' + dd + '/' + yyyy;
    return today;
  }

  handleEvent (event, picker) {
    const FormatedStartDate = this.convertDateToFormat(picker.startDate._d);
    const FormatedEndDate = this.convertDateToFormat(picker.endDate._d);
    const StartEndDate = FormatedStartDate + ' - ' + FormatedEndDate;
    if (this.state.dateSrting !== StartEndDate) {
      this.setState({
        startDate: FormatedStartDate,
        endDate: FormatedEndDate,
        dateSrting: StartEndDate
      });
      this.props.onDateChange(FormatedStartDate, FormatedEndDate);
    }
  }

  render () {
    return (
      <DateRangePicker
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        onEvent={this.handleEvent}
        showDropdowns={true}
      >
        <input
          type="text"
          name="daterange"
          className="date-picker-range"
          placeholder="Select Date Range"
          value={this.state.dateSrting}
        />{' '}
      </DateRangePicker>
    );
  }
}
DatePicker.propTypes =
{
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired
};
export default DatePicker;
